/*
 * @Author: your name
 * @Date: 2021-05-04 13:36:12
 * @LastEditTime: 2021-11-08 15:26:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dhr_frontend\src\routes\modules\recruitment.js
 */
export default [
  {
    name: 'guideList',
    path: '/guide/list',
    component: () => import('@/views/guide/list.vue'),
    meta: {
      title: '办事指南'
    }
  },
]
